__webpack_public_path__ = window.PUBLIC_URL + "/"; // eslint-disable-line

(async () => {
  await import("./bootstrap.js");
})();
